import React from "react";
import Inbox from "../components/Inbox";

const InboxPage = () => (
  <div className="container px-3">
    <h2 className="page-title mb-4">📩 Inbox</h2>
    <Inbox />
  </div>
);

export default InboxPage;
